"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-flow-strip-types", "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}
var shallowEqual = function shallowEqual(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  return keysA.length === keysB.length && keysA.every(function (key) {
    return b.hasOwnProperty(key) && b[key] === a[key];
  });
};

var _default = shallowEqual;
exports.default = _default;